import React from "react";
import { Typography, Divider, Box, List, ListItem } from "@mui/material";
import StyledButton from "../StyledButton/StyledButton";
import colors from "../../styles/colors";

interface TextContainerProps {
  title: string;
  description: string | string[];
  isAnimatingOut: boolean;
  left: string;
  zIndex?: number;
  onButtonClick?: () => void;
  colorIndex?: number; // Add this prop to specify which color to use
}

const TextContainer: React.FC<TextContainerProps> = ({
  title,
  description,
  isAnimatingOut,
  left,
  zIndex,
  onButtonClick,
  colorIndex = 3, // Default to the first color if not specified
}) => {
  // Convert string to array if needed
  const descriptionItems = Array.isArray(description)
    ? description
    : [description];

  return (
    <Box
      className={`text-container ${isAnimatingOut ? "slide-out" : "slide-in"}`}
      sx={{
        position: "absolute",
        left,
        top: "50%",
        transform: "translate(-50%, -50%)",
        color: "white",
        background: "none",
        border: "none",
        zIndex,
        pointerEvents: "auto",
      }}
    >
      <Typography
        variant="h2"
        sx={{
          color: "white",
          paddingBottom: {
            xs: "0.4rem",
            sm: "1rem",
            md: "1.5rem",
            lg: "2rem",
          },
        }}
      >
        {title}
      </Typography>

      <Typography
        variant="h5"
        sx={{
          textAlign: "center",
          paddingTop: "1rem",
          paddingBottom: {
            xs: "1rem", 
            sm: "2rem",
            md: "3rem",
            lg: "4rem",
            xl: "5rem",
          },
        }}
      >
        "{description}"
      </Typography>
      <StyledButton
        className="hover-button"
        onClick={onButtonClick}
        sx={{
          fontSize: {
            xs: "0.6rem",
            sm: "1rem",
            md: "1.2rem",
            lg: "1.5rem",
            xl: "1.8rem",
          },
          position: "relative",
        }}
      >
        SEE DETAILS
      </StyledButton>
    </Box>
  );
};

export default TextContainer;
